import {useMemo, useState} from 'react';
//mui
import {Box} from '@mui/material';
//store
import {useAppSelector} from '@/store/hooks';
import {getDashboardStatisticsSelector} from '@/store/organization-dashboard';
//icons
import {ReactComponent as StatisticsCheckIcon} from '@/assets/icons/statistics/statistics-checked.svg';
import {ReactComponent as StatisticsGuestsIcon} from '@/assets/icons/statistics/statistics-guests.svg';
import {ReactComponent as StatisticsItemsIcon} from '@/assets/icons/statistics/statistics-items.svg';
import {ReactComponent as StatisticsMealsIcon} from '@/assets/icons/statistics/statistics-meals.svg';
import {ReactComponent as StatisticsSoldIcon} from '@/assets/icons/statistics/statistics-sold.svg';
//components
import StatisticsInfoItem from './StatisticsInfoItem';
import Modal from '@/shared/components/Modal';
import StatisticTablesSold from './StatisticsInfoTables/StatisticTablesSold';
import StatisticUnknownGuests from './StatisticsInfoTables/StatisticUnknownGuests';
import StatisticSpecialMeals from './StatisticsInfoTables/StatisticSpecialMeals';
import StatisticAuctionItems from './StatisticsInfoTables/StatisticAuctionItems';
import StatisticCheckedIn from './StatisticsInfoTables/StatisticCheckedIn';
//types
import {IOrganizationDashboardStatistics} from '@/utils/types';
//enums
import {STATISTIC} from '@/utils/enums';
//constants
import {AUCTION_ITEMS, CHECKED_IN, SPECIAL_MEALS, TABLES_SOLD, UNKNOWN_GUSTS} from '@/utils/constants';
//styles
import {statisticsInfoStyle} from './StatisticsInfo.styles';

const StatisticsInfo = () => {
	const statistics = useAppSelector(getDashboardStatisticsSelector) as IOrganizationDashboardStatistics;

	const [activeStatisticsInfoTitle, setActiveStatisticsInfoTitle] = useState<string>();
	const [isTableInfoModalOpen, setIsTableInfoModalOpen] = useState(false);

	const activeStatisticsTable = useMemo(() => {
		switch (activeStatisticsInfoTitle) {
			case STATISTIC.TABLES_SOLD:
				return <StatisticTablesSold />;

			case STATISTIC.UNKNOWN_GUESTS:
				return <StatisticUnknownGuests />;

			case STATISTIC.SPECIAL_MEALS:
				return <StatisticSpecialMeals />;

			case STATISTIC.AUCTION_ITEMS:
				return <StatisticAuctionItems />;

			case STATISTIC.CHECKED_IN:
				return <StatisticCheckedIn />;

			default:
				return <StatisticTablesSold />;
		}
	}, [activeStatisticsInfoTitle]);

	const titleCheck = `${statistics.tablesSold} of ${statistics.allTables}`;
	const titleGuests = `${statistics.unknownGuests} of ${statistics.allGuests}`;
	const titleCheckedIn = `${statistics.checkedIn} of ${statistics.allGuests}`;
	const titleItems = `${statistics.auctionItems} of ${statistics.allItems}`;

	const handleStatisticsClick = (title: string) => {
		setActiveStatisticsInfoTitle(title);
		setIsTableInfoModalOpen(true);
	};

	const handleCloseTableInfoModal = () => setIsTableInfoModalOpen(false);

	return (
		<Box sx={statisticsInfoStyle.wrapper}>
			<Box sx={statisticsInfoStyle.content}>
				<StatisticsInfoItem
					title={titleCheck}
					description={TABLES_SOLD}
					icon={StatisticsCheckIcon}
					onClick={handleStatisticsClick}
				/>

				<StatisticsInfoItem
					title={titleGuests}
					description={UNKNOWN_GUSTS}
					icon={StatisticsGuestsIcon}
					onClick={handleStatisticsClick}
				/>

				<StatisticsInfoItem
					title={statistics.specialMeals}
					description={SPECIAL_MEALS}
					icon={StatisticsMealsIcon}
					onClick={handleStatisticsClick}
				/>

				<StatisticsInfoItem
					title={titleItems}
					description={AUCTION_ITEMS}
					icon={StatisticsItemsIcon}
					onClick={handleStatisticsClick}
				/>

				<StatisticsInfoItem
					title={titleCheckedIn}
					description={CHECKED_IN}
					icon={StatisticsSoldIcon}
					onClick={handleStatisticsClick}
				/>
			</Box>

			<Modal
				title={activeStatisticsInfoTitle}
				onClose={handleCloseTableInfoModal}
				open={isTableInfoModalOpen}
				sx={statisticsInfoStyle.modal}
			>
				{activeStatisticsTable}
			</Modal>
		</Box>
	);
};

export default StatisticsInfo;
